import {Component, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, filter, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {AuthUntilUserRoleService} from '../../core/authentication/auth-until-user-role.service';
import {BadgesRessource} from '../../../../../micromate-learn-lib/src/lib/services/rest/badges-ressource.service';
import {EventRecorderService} from '../../../../../micromate-learn-lib/src/lib/services/event/event-recorder.service';
import {TabEventType} from '../../../../../micromate-learn-lib/src/lib/services/event/TabEventType';
import {ErrorNotificationService} from '../../core/error-notification.service';
import {LearnerBadgesResponseDto} from '../../../../../micromate-learn-lib/src/lib/types/LearnerBadgesResponseDto';

@Component({
    selector: 'mm-learning-badge',
    templateUrl: './learning-badge.component.html',
    styleUrls: ['./learning-badge.component.scss'],
    standalone: false
})
export class LearningBadgeComponent implements OnInit, OnDestroy {
    public badges: BehaviorSubject<LearnerBadgesResponseDto | undefined> = new BehaviorSubject<LearnerBadgesResponseDto | undefined>(undefined);
    public badges$ = this.badges.pipe(filter((value): value is LearnerBadgesResponseDto => value !== undefined));
    public paramsSubscription = new Subscription();
    public openInConversation: boolean = false;

    private learnerId: string | undefined;

    constructor(private activatedRoute: ActivatedRoute,
                private badgesService: BadgesRessource,
                private authUntilUserRoleService: AuthUntilUserRoleService,
                private router: Router,
                private eventRecorderService: EventRecorderService,
                public errorNotificationService: ErrorNotificationService) {
    }

    public ngOnInit(): void {
        this.paramsSubscription = this.activatedRoute.queryParamMap.pipe(
            map(params => {
                this.learnerId = params.get('learnerid') ?? undefined;
                this.openInConversation = params.get('openInConversation') === 'true';
            }))
            .subscribe(async () => {
                await this.getBadges();
                await this.recordTabEvents();
            });
    }

    public ngOnDestroy(): void {
        this.paramsSubscription.unsubscribe();
    }

    private async getBadges(): Promise<void> {
        if (this.learnerId === undefined) {
            const badgesPromise = this.badgesService.getLearnerBadgesForLearn();
            this.badges.next(await badgesPromise);
        } else {
            const isAdmin = await this.authUntilUserRoleService.assertAdmin().toPromise();
            if (isAdmin !== true) {

                void this.router.navigate(['/learn']);
            } else {
                const badgesPromise = this.badgesService.getLearnerBadgesForLearn(this.learnerId);
                this.badges.next(await badgesPromise);
            }
        }
    }

    private async recordTabEvents(): Promise<void> {
        await this.eventRecorderService.recordTabOpenedEventForLearn(this.learnerId, TabEventType.TabBadgeOpened, this.eventRecorderService.createTabOpenEventPayloadForLearn(this.openInConversation));
    }

}
